import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from './ui/dialog';
import LoginForm from './LoginForm';
import RegisterForm from './RegisterForm';
import ForgotPasswordForm from './ForgotPasswordForm';

const AuthModal = ({ isOpen, onClose, initialMode = 'login' }) => {
  const [mode, setMode] = useState(initialMode);

  // Reset mode when modal opens with a new initialMode
  useEffect(() => {
    if (isOpen) {
      setMode(initialMode);
    }
  }, [isOpen, initialMode]);

  const switchToLogin = () => setMode('login');
  const switchToRegister = () => setMode('register');
  const switchToForgotPassword = () => setMode('forgot-password');

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md bg-[#0f0f0f] border border-[#333] text-[#F5F5DC] max-h-[90vh] overflow-y-auto">
        <DialogTitle className="sr-only">Account access</DialogTitle>
        <DialogDescription className="sr-only">Sign in to your account or create a new one</DialogDescription>
        {mode === 'login' ? (
          <LoginForm 
            onClose={onClose} 
            switchToRegister={switchToRegister}
            switchToForgotPassword={switchToForgotPassword} 
          />
        ) : mode === 'register' ? (
          <RegisterForm onClose={onClose} switchToLogin={switchToLogin} />
        ) : (
          <ForgotPasswordForm 
            onClose={onClose} 
            switchToLogin={switchToLogin} 
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default AuthModal;